export interface RelevantStudentInformationData {
  schoolAssignedStudentId?: string;
  ontarioEducationNumber?: string;
  albertaStudentNumber?: string;
  personalEducationNumber?: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors?: string[];
}

const STUDENT_ID_MAX_LENGTH = 15;
const STUDENT_ID_REGEX = /^(?! )([\w -]*)(?<! )$/;
const PROVINCIAL_NUMBER_LENGTH = 9;
const DIGITS_ONLY_REGEX = /^\d+$/;

function validateStudentId(value: string, errors: string[]) {
  if (value === '') return;
  if (value.length > STUDENT_ID_MAX_LENGTH) {
    errors.push('Student ID must be no more than 15 characters long.');
  }
  if (!STUDENT_ID_REGEX.test(value)) {
    errors.push('Student ID can only include letters, numbers, hyphens, underscores, and spaces.');
  }
}

function validateProvincialNumber(value: string, label: string, errors: string[]) {
  if (value === '') return;
  if (!DIGITS_ONLY_REGEX.test(value)) {
    errors.push(`${label} must contain only digits.`);
    return;
  }
  if (value.length !== PROVINCIAL_NUMBER_LENGTH) {
    errors.push(`${label} must be exactly ${PROVINCIAL_NUMBER_LENGTH} digits.`);
  } else if (value.startsWith('0')) {
    errors.push(`${label} must not start with zero.`);
  }
}

export function validateRelevantStudentInformation(data: RelevantStudentInformationData): ValidationResult {
  const errors: string[] = [];

  if (data.schoolAssignedStudentId !== undefined) {
    validateStudentId(data.schoolAssignedStudentId, errors);
  }

  if (data.ontarioEducationNumber !== undefined) {
    validateProvincialNumber(data.ontarioEducationNumber, 'OEN', errors);
  }

  if (data.albertaStudentNumber !== undefined) {
    validateProvincialNumber(data.albertaStudentNumber, 'ASN', errors);
  }

  if (data.personalEducationNumber !== undefined) {
    validateProvincialNumber(data.personalEducationNumber, 'PEN', errors);
  }

  if (errors.length > 0) {
    return { isValid: false, errors };
  }

  return { isValid: true };
}
